var render = function (_h,_vm) {var _c=_vm._c;return _c('ValidationProvider',{attrs:{"name":_vm.props.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("error",[(errors.length)?_c('div',{staticClass:"control-hint control-hint--styling_default control-hint--variant_error"},[_vm._v(_vm._s(errors[0]))]):_vm._e()],{"errors":errors})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }